import React, {useState, useEffect} from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Box, CssBaseline, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Collapse, Typography,Menu, MenuItem, Avatar, Divider,Tooltip } from '@mui/material';
import { Logout, Lock, AccountCircle } from '@mui/icons-material';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import { Icon } from "@iconify/react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { navConfig } from './Menuitem';
import { useDispatch, useSelector, } from "react-redux";
import { clearUploadedDocument, toggleFullView, updateDocumentName } from "../../store/reducers/uploadDocumentSlice";
import ProfileMenu from './ProfileMenu';
import { useLogger } from '../../hooks/useLogger';
import { pdfToolApi } from '../../services/PdfEditor/pdfToolApi';
import { esignIcons } from '../Esign/icons';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: open ? drawerWidth : 100,
  // width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 65px)`,
  width: '100%',
  height: '80px'
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: open ? drawerWidth : 100,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    width: open ? drawerWidth : 100,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    border: 'none',
    overflowX: 'hidden',
  },
}));

const ToggleButton = styled(IconButton)(({ theme, open }) => ({
  transition: theme.transitions.create(['left'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  position: 'fixed',
  left: open ? '8.6em' : '3.2em',
  top: '4em',
  background: '#fff',
  border: "5px solid #f9f9f9",
  width: '55px',
  height: '55px',
  '&:hover': {
    background: '#fff',
  },
  zIndex: 2,
}));

export default function MiniDrawer({ open, setOpen, openSideBar, setOpenSideBar }) {
  const logEvent = useLogger();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { uploadedDocument} = useSelector((state) => state.uploadDocument);
  const { profileData } = useSelector((state) => state.profile);
  const [isEditing, setIsEditing] = useState(false);
  const [docName, setDocName] = useState("");
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const isMobileActive = (paths) => paths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));
  const mobileHomeIcon = (color) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.0001 17C14.2006 17.6224 13.1504 18 12.0001 18C10.8499 18 9.79965 17.6224 9.00012 17" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M2.35151 13.2135C1.99849 10.9162 1.82198 9.76763 2.25629 8.74938C2.69059 7.73112 3.65415 7.03443 5.58126 5.64106L7.02111 4.6C9.41841 2.86667 10.6171 2 12.0001 2C13.3832 2 14.5818 2.86667 16.9791 4.6L18.419 5.64106C20.3461 7.03443 21.3097 7.73112 21.744 8.74938C22.1783 9.76763 22.0018 10.9162 21.6487 13.2135L21.3477 15.1724C20.8473 18.4289 20.597 20.0572 19.4291 21.0286C18.2612 22 16.5538 22 13.1389 22H10.8613C7.44646 22 5.73903 22 4.57112 21.0286C3.40321 20.0572 3.15299 18.4289 2.65255 15.1724L2.35151 13.2135Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
  const mobileDocumentsIcon = (color) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5" stroke={color} strokeWidth="1.5" />
      <path d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368V1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z" fill={color} />
      <path d="M8 12H16" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8 15.5H13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
  const mobileSignersIcon = (color) => (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.5" cy="6.25016" r="4.16667" stroke={color} strokeWidth="1.5625" />
      <path d="M18.75 9.37484C20.4759 9.37484 21.875 8.20891 21.875 6.77067C21.875 5.33243 20.4759 4.1665 18.75 4.1665" stroke={color} strokeWidth="1.5625" strokeLinecap="round" />
      <path d="M6.25 9.37484C4.52411 9.37484 3.125 8.20891 3.125 6.77067C3.125 5.33243 4.52411 4.1665 6.25 4.1665" stroke={color} strokeWidth="1.5625" strokeLinecap="round" />
      <ellipse cx="12.5" cy="17.7082" rx="6.25" ry="4.16667" stroke={color} strokeWidth="1.5625" />
      <path d="M20.8334 19.7918C22.6607 19.3911 23.9584 18.3763 23.9584 17.1877C23.9584 15.9991 22.6607 14.9842 20.8334 14.5835" stroke={color} strokeWidth="1.5625" strokeLinecap="round" />
      <path d="M4.16663 19.7918C2.33929 19.3911 1.04163 18.3763 1.04163 17.1877C1.04163 15.9991 2.33929 14.9842 4.16663 14.5835" stroke={color} strokeWidth="1.5625" strokeLinecap="round" />
    </svg>
  );
  const mobileMoreIcon = (color) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9959 12H12.0049" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15.9998 12H16.0088" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.99981 12H8.00879" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z" stroke={color} strokeWidth="1.5" />
    </svg>
  );
  const mobileNavItems = [
    { label: "Home", path: "/dashboard", icon: mobileHomeIcon },
    { label: "Documents", path: "/esign/documents", icon: mobileDocumentsIcon },
    { label: "New eSign", path: "/esign/new-esign", primary: true },
    { label: "Signers", path: "/esign/signers", icon: mobileSignersIcon },
    { label: "More", path: "/settings", icon: mobileMoreIcon },
  ];
  
  const [openSubmenu, setOpenSubmenu] = useState(() => {
    const initialState = {};
    navConfig.forEach((item) => {
      if (item.children && item.children.some(subItem => subItem.path === location.pathname)) {
        initialState[item.id] = true;
      }
    });
    return initialState;
  });

  // Ensure submenu opens when a subitem is selected
  useEffect(() => {
    setOpenSubmenu((prev) => {
      const newState = { ...prev };
      navConfig.forEach((item) => {
        if (item.children && item.children.some(subItem => subItem.path === location.pathname)) {
          newState[item.id] = true;
        }
      });
      return newState;
    });
  }, [location.pathname]);

  useEffect(() => {
    if(uploadedDocument?.data?.document_name)
    {
      setDocName(uploadedDocument?.data?.document_name);
    }
  }, [uploadedDocument])
  
  const handleToggleSubmenu = (id) => {
    if(open)
    {
      setOpenSubmenu((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    }
  };

  const handleNameClick = () => {
    setIsEditing(true);
  };
  
  const handleNameChange = (e) => {
    setDocName(e.target.value);
  };
  
  const handleSaveName = async () => {
    if (!docName.trim() || docName === uploadedDocument?.data?.document_name) {
      setIsEditing(false);
      return;
    }
  
    logEvent('Clicked', `Document name change to ${docName}`, 'Documents/Drafts');
    if(pdfEditortoken?.access && docName.trim())
    {
      try {        
        const fullName = uploadedDocument?.data?.document_name || "";
        let newName = docName.trim();
        const dotIndex = newName.lastIndexOf(".");
        if (dotIndex !== -1) {
          newName = newName.slice(0, dotIndex);
        }
        const payload = {new_document_name: newName };
        const response = await pdfToolApi.chnagePdfName(pdfEditortoken?.access, payload, uploadedDocument?.data?.document_id);
        // console.log(response)
        if (response.status) {
          newName = newName + ".pdf";
          if (newName === fullName) {
            setIsEditing(false);
            return;
          }

          // console.log("Saving as:", newName);
          if (docName !== fullName) {
            dispatch({
              type: "uploadDocument/updateDocumentName",
              payload: { document_id: uploadedDocument.data.document_id, document_name: newName },
            });
          }
          else {
            setDocName(uploadedDocument?.data?.document_name);
          }
          setDocName(newName);
          setIsEditing(false);
        }
      } catch (err) {
        console.error(err);
        alert("Error updating name");
        setDocName(uploadedDocument?.data?.document_name || "");
        setIsEditing(false);
      }
    }
  };
  

  return (
    (!uploadedDocument ||
      (uploadedDocument?.data?.document_id && !uploadedDocument?.fullView) ||
      (uploadedDocument?.data?.document_id)) && (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Box className="mobile-status-spacer" />
      {!uploadedDocument?.fullView && !["/esign/documents", "/esign/bulk-esign", "/esign/new-esign"].includes(location.pathname) && (
        <Box className="mobile-app-header">
          <img src={`${process.env.PUBLIC_URL}/images/meon-tech.png`} alt="Logo" className="mobile-app-logo" onClick={() => {
            logEvent('Click', 'click on logo in mobile header', 'header');
            dispatch(clearUploadedDocument());
            navigate("/dashboard");
          }} />
          <ProfileMenu />
        </Box>
      )}
      <AppBar className="desktop-appbar" position="fixed" open={open} sx={{ background: "#fff", color: "#000", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 0px inset" }}>
        <Toolbar sx={{ height: "80px", display: "flex", justifyContent: "space-between", }}>
          { uploadedDocument?.fullView === true ? 
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 1, alignItems: 'center', width: "100%" }}>
              <Box sx={{ display: "flex", cursor: "pointer", alignItems: "center" }}>
                <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"  onClick={() => { logEvent('Click', 'back to new-esign from pdf-editor', 'new-esign/pdfeditor'); dispatch(clearUploadedDocument()); dispatch(toggleFullView()); setOpenSideBar(true) }} >
                <path d="M9 18L2 10L9 2" stroke="#2556AB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {isEditing ? (
                  <input
                    type="text"
                    value={docName}
                    onChange={handleNameChange}
                    onBlur={handleSaveName}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleSaveName();
                      if (e.key === "Escape") {
                        setDocName(uploadedDocument?.data?.document_name || "");
                        setIsEditing(false);
                      }
                    }}
                    autoFocus
                    style={{
                      fontSize: "20px",
                      fontWeight: 600,
                      border: "1px solid #D1D1D1",
                      outline: "none",
                      background: "transparent",
                      color: "#1D1D1D",
                      width: "fit-content",
                      marginLeft: 16,
                    }}
                  />
                ) : (
                  <Tooltip title={uploadedDocument?.data?.document_name}>
                    <Typography
                      noWrap
                      component="p"
                      sx={{
                        fontSize: "20px",
                        fontWeight: 600,
                        lineHeight: "20px",
                        color: "#1D1D1D",
                        ml: 2,
                        cursor: "text", // show text cursor
                      }}
                      onClick={handleNameClick}
                    >
                      {(() => {
                        const fullName = uploadedDocument?.data?.document_name || "";
                        const dotIndex = fullName.lastIndexOf(".");
                        const extension = dotIndex !== -1 ? fullName.slice(dotIndex) : "";
                        const baseName = dotIndex !== -1 ? fullName.slice(0, dotIndex) : fullName;
                        return baseName.length > 20 ? baseName.slice(0, 20) + "..." + extension : fullName;
                      })()}
                    </Typography>
                  </Tooltip>
                )}

              </Box>
              <ProfileMenu />
            </Box>
            :
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 1, alignItems: 'center', width: "100%", }}>
              <img src={`${process.env.PUBLIC_URL}/images/meon-tech.png`} alt="Logo" style={{ height: 35, cursor: "pointer" }} onClick={() => {
                logEvent('Click', 'click on logo in header', 'header');
                dispatch(clearUploadedDocument());
                window.location.replace(`${process.env.PUBLIC_URL}/esign/new-esign`);
              }}  />
              <ProfileMenu />
            </Box>
          }
        </Toolbar>
      </AppBar>
      {(!uploadedDocument || !uploadedDocument?.data?.document_id || (location.pathname !== "/esign/new-esign" && location.pathname !== "/esign/pdfeditor")) && (
        !location.pathname.includes("choose-template") ? 
        <Drawer className="desktop-sidebar" variant="permanent" open={open}>
          <List sx={{marginTop: "80px"}}>
            <ToggleButton open={open} onClick={() => setOpen(!open)}>
                {open ? <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.55084 14.983L2.06779 8.49998L8.55084 2.01693" stroke="#185CB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg> : <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.06779 14.983L8.55085 8.5L2.06779 2.01695" stroke="#185CB7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                }
            </ToggleButton>
            {navConfig.map((item) => {
              const isActive = location.pathname === item.path || (item.children && item.children.some(sub => sub.path === location.pathname));
              return (
                <React.Fragment key={item.id}>
                  <ListItem disablePadding sx={{ display: "block", mt: "12px" }}>
                    {item.children ? (
                      <>
                        <ListItemButton
                          sx={{ ml: open ? "21px" : "", justifyContent: open ? "initial" : "center", height: "48px" }}
                          onClick={() => {logEvent('Click', `open the dropdown of ${item.title} menu`, 'header'); handleToggleSubmenu(item.id)}}
                        >
                          <ListItemIcon sx={{ minWidth: 0, justifyContent: "center", mr: open ? "15px" : "", 
                              background: isActive && !open ? "linear-gradient(to right, #2257AD, #B01121)" : open ? "transparent":"#F4F4F4",
                              width: !open ? "50px" : 'Auto',
                              height: !open ? "50px" : 'Auto',
                              borderRadius: !open ? "320px" : '',
                              alignItems: !open ? "center" : '',
                            }}>
                            {item.icon(isActive && !open ? "#fff" : "#000000")}
                          </ListItemIcon>
                          {open && (<>
                            <ListItemText primary={item.title} sx={{ opacity: open ? 1 : 0, "& .MuiTypography-root": { fontSize: "15px", fontWeight: "500", color: isActive && !open ? "#fff" : "#1D1D1D" } }} />
                            <Icon icon={openSubmenu[item.id] ? "mdi:chevron-up" : "mdi:chevron-down"} />
                            </>
                          )}
                        </ListItemButton>
                        {open && (
                          <Collapse in={openSubmenu[item.id]} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {item.children.map((subItem) => (
                                <Link key={subItem.id} to={subItem.path} style={{ textDecoration: "none", color: "inherit" }}>
                                  <ListItemButton sx={{ ml: open ? 6.5 : 2, pl: 3, height: "48px",
                                    background: location.pathname === subItem.path ? "linear-gradient(to right, #2257AD, #B01121)" : "transparent", borderRadius: "320px 0 0 320px" }}>
                                    <ListItemText primary={subItem.title} sx={{ "& .MuiTypography-root": { fontSize: "14px", fontWeight: "400", color: location.pathname === subItem.path ? "#fff" : "#1D1D1D" } }} />
                                  </ListItemButton>
                                </Link>
                              ))}
                            </List>
                          </Collapse>
                        )}
                      </>
                    ) : (
                      <Link to={item.path} style={{ textDecoration: "none", color: "inherit", position: "relative",  }}>
                        {isActive && open && (                     
                        <Box sx={{ height: "48px", width: "27px", background: "linear-gradient(-90deg, #2257AD 0%, #B01121 100%)", position: "absolute", left: "-15px", borderRadius: "0 320px 320px 0" }} />)}
                        <ListItemButton sx={{ justifyContent: open ? "initial" : "center", height: "48px", background: location.pathname === item.path && open ? "linear-gradient(to right, #2257AD, #B01121)" : "transparent", ml: open ? "21px" : "", borderRadius: "320px 0 0 320px" }}>
                          <ListItemIcon sx={{ minWidth: 0, justifyContent: "center", mr: open ? "15px" : "", m:"",
                              background: isActive && !open ? "linear-gradient(to right, #2257AD, #B01121)" : !isActive && !open ? "#F4F4F4" : "transparent",
                              width: (isActive && !open) || (!isActive && !open) ? "50px" : 'Auto',
                              height: (isActive && !open) || (!isActive && !open) ? "50px" : 'Auto',
                              borderRadius: (isActive && !open) || (!isActive && !open) ? "320px" : '',
                              alignItems: (isActive && !open) || (!isActive && !open) ? "center" : '',
                            }}>
                          {item.icon((isActive && !open) || (isActive && open) ? "#fff" : "#000000")}
                          </ListItemIcon>
                          {open && (<ListItemText primary={item.title} sx={{ opacity: open ? 1 : 0, "& .MuiTypography-root": { fontSize: "15px", fontWeight: "500", color: location.pathname === item.path ? "#fff" : "#1D1D1D" } }} />)}
                        </ListItemButton>
                      </Link>
                    )}
                  </ListItem>
                </React.Fragment>
              );
            })}
          </List>
        </Drawer> : ""
      )}
      {!uploadedDocument?.fullView && location.pathname !== "/esign/new-esign" && (
        <Box className="mobile-bottom-nav">
          {mobileNavItems.map((item) => {
            const active = item.primary
              ? isMobileActive(["/esign/new-esign", "/esign/pdfeditor"])
              : isMobileActive([item.path]);
            return (
              <Box
                key={item.label}
                className={`mobile-bottom-nav-item${active ? " active" : ""}${item.primary ? " primary" : ""}`}
                onClick={() => navigate(item.path)}
              >
                <Box className="mobile-bottom-nav-icon">
                  {item.primary ? esignIcons.mobilesignIcon : item.icon(active ? "#185CB7" : "#9A9A9A")}
                </Box>
                <Typography component="span">{item.label === "New eSign" ? "" : item.label}</Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </Box>
    )
    
  );
}
